import "./es.object.assign-7e79fd7b.js";
import { c as r } from "./index-8b07dec9.js";
import { useState as he, useRef as re, useEffect as be } from "react";
import l, { css as c } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as fe } from "./getMetrics-953aa4f8.js";
import { Button as oe } from "./button.js";
import { a as Le } from "./index-5d0f31c6.js";
import "./carousel.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { jsx as p, jsxs as _ } from "react/jsx-runtime";
import { InputState as O, HelperText as Ce } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./web.set-timeout-72b6430f.js";
import "@ucl/shared-component-foundations";
import "./es.object.keys-9d66766f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./es.string.link-fd2676c6.js";
import { useAccessibilityProps as y } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as Oe } from "./uniqueId.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./combineRefs-c9ad2c39.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./iconButton.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.date.to-string-6ed49878.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./es.global-this-a7f40ce1.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
var ye = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__Container",
  componentId: "sc-1ct1vm-0"
})(["&.InlineText{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.Container);
}), We = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__OpenContainer",
  componentId: "sc-1ct1vm-1"
})(["&.InlineText__OpenContainer{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.OpenContainer);
}), Be = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__InputContainer",
  componentId: "sc-1ct1vm-2"
})(["&.InlineText__InputContainer{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.InputContainer);
}), ge = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__InLineWrapper",
  componentId: "sc-1ct1vm-3"
})(["&.InlineText__InlineWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.InLineWrapper);
}), Ne = /* @__PURE__ */ l.input.withConfig({
  displayName: "inLineText__TextField",
  componentId: "sc-1ct1vm-4"
})(["&.InlineText__TextField{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.TextField);
}), Pe = /* @__PURE__ */ l.span.withConfig({
  displayName: "inLineText__TextWrapper",
  componentId: "sc-1ct1vm-5"
})(["&.InlineText__TextWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.TextWrapper);
}), we = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__SaveButtonWrapper",
  componentId: "sc-1ct1vm-6"
})(["&.InlineText__SaveButtonWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.SaveButtonWrapper);
}), Se = /* @__PURE__ */ l.span.withConfig({
  displayName: "inLineText__IconWrapper",
  componentId: "sc-1ct1vm-7"
})(["&.InlineText__IconWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.IconWrapper);
}), De = /* @__PURE__ */ l.label.withConfig({
  displayName: "inLineText__Label",
  componentId: "sc-1ct1vm-8"
})(["&.InlineText__Label{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.Label);
}), ae = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__HelperTextWrapper",
  componentId: "sc-1ct1vm-9"
})(["&.InlineText__HelperTextWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.HelperTextWrapper);
}), je = /* @__PURE__ */ l.div.withConfig({
  displayName: "inLineText__ButtonWrapper",
  componentId: "sc-1ct1vm-10"
})(["&.InlineText__ButtonWrapper{", "}"], function(n) {
  var e = n.theme.components.inLineText;
  return c(e.ButtonWrapper);
}), pe = "inline-text", $t = function(e) {
  var h, b, g, N, P, w, S, f, D, j, R, k, F, H, E = e.size, x = E === void 0 ? "large" : E, q = e.value, K = e.placeholder, L = e.label, A = e.isDisabled, o = A === void 0 ? !1 : A, $ = e.isOpen, le = $ === void 0 ? !1 : $, M = e.isRequired, z = M === void 0 ? !1 : M, X = e.showRequiredIndicator, ce = X === void 0 ? z : X, G = e.onClickOpen, J = e.onClickSave, Q = e.onClickCancel, U = e.onTextChange, V = e.accessibilityOptions, t = V === void 0 ? {} : V, se = e.onBlur, C = e.helperTextProp, Y = e.inputState, i = e.customButtonProperties, me = fe({
    label: "InlineText"
  }), Z = he(le), s = Z[0], W = Z[1], I = re(null), T = re(Oe(pe)), a = Y || O.NONE, d = C;
  if (Y || (a = O.NONE), C)
    d = Object.assign({}, C, {
      inputState: a,
      secondaryProp: Object.assign({}, C.secondaryProp)
    });
  else {
    var B;
    d = (B = {
      inputState: a
    }, B[a === O.ERROR ? "secondaryProp" : "defaultProp"] = {
      id: (a === O.ERROR ? "invalid" : "valid") + "_" + pe + "_helperText"
    }, B);
  }
  var m = {
    defaultId: ((h = d) == null || (h = h.defaultProp) == null ? void 0 : h.id) || "default_" + T.current + "_message_id",
    secondaryId: ((b = d) == null || (b = b.secondaryProp) == null ? void 0 : b.id) || "secondary_" + T.current + "_message_id"
  }, ee = function() {
    J && J(), W(!s);
  }, de = function(v) {
    U && U(v.target.value);
  }, ue = function(v) {
    v.code === "Escape" ? te() : v.code === "Enter" && ee();
  }, ne = function() {
    G && G(), W(!s);
  };
  be(function() {
    if (s && I != null && I.current) {
      var u;
      (u = I.current) == null || u.focus();
    }
  }, [s]);
  var xe = function(v) {
    (v.code === "Enter" || v.code === "Space") && ne();
  }, te = function() {
    Q && Q(), W(!s);
  }, Te = y("button", Object.assign({
    ariaLabel: (t == null || (g = t.component) == null ? void 0 : g.ariaLabel) || "Edit " + L
  }, t == null ? void 0 : t.component, {
    tabIndex: 0,
    ariaDisabled: o,
    ariaLabelledBy: T.current + "_label " + (m == null ? void 0 : m.defaultId) + " " + (m == null ? void 0 : m.secondaryId)
  })), ve = y("button", Object.assign({
    ariaLabel: (t == null || (N = t.saveButton) == null ? void 0 : N.ariaLabel) || "Save"
  }, t == null ? void 0 : t.saveButton, {
    tabIndex: 0,
    ariaDisabled: o
  })), _e = y("button", Object.assign({
    ariaLabel: (t == null || (P = t.cancelButton) == null ? void 0 : P.ariaLabel) || "Cancel"
  }, t == null ? void 0 : t.cancelButton, {
    tabIndex: 0,
    ariaDisabled: o
  })), Ie = y("input", Object.assign({
    ariaLabel: (t == null || (w = t.input) == null ? void 0 : w.ariaLabel) || L
  }, t == null ? void 0 : t.input, {
    tabIndex: o ? -1 : 0,
    ariaDisabled: o,
    ariaLabelledBy: T.current + "_label " + (m == null ? void 0 : m.defaultId) + " " + (m == null ? void 0 : m.secondaryId)
  })), ie = /* @__PURE__ */ p(Ce, {
    inputState: a,
    secondaryProp: Object.assign({
      id: m.secondaryId
    }, (S = d) == null ? void 0 : S.secondaryProp),
    defaultProp: {
      id: m.defaultId,
      helperText: ((f = d) == null || (f = f.defaultProp) == null ? void 0 : f.helperText) || ""
    },
    disabled: o
  });
  return /* @__PURE__ */ _(ye, Object.assign({}, me, {
    className: r("InlineText"),
    children: [/* @__PURE__ */ _(De, {
      htmlFor: T.current,
      id: T.current + "_label",
      className: r("InlineText__Label"),
      children: [L, L && ce && /* @__PURE__ */ _("span", {
        "aria-hidden": "true",
        children: [" ", "*"]
      })]
    }), s ? /* @__PURE__ */ p(We, {
      className: r("InlineText__OpenContainer"),
      children: /* @__PURE__ */ _(Be, {
        className: r("InlineText__InputContainer", "InlineText__InputContainer--" + x, {
          "InlineText__InputContainer--error": a === "error"
        }),
        children: [/* @__PURE__ */ p(Ne, Object.assign({
          id: T.current,
          ref: I,
          className: r("InlineText__TextField", "InlineText__TextField--" + a, "InlineText__TextField--" + x, {
            "InlineText__TextField--open": s,
            "InlineText__TextField--error": a === "error",
            "InlineText__TextField--disabled": o
          }),
          value: q,
          placeholder: K,
          onChange: de,
          "aria-label": "input",
          "aria-required": z,
          onKeyDown: ue,
          onBlur: se
        }, Ie)), d && /* @__PURE__ */ p(ae, {
          className: r("InlineText__HelperTextWrapper", "InlineText__HelperTextWrapper--mobile", "InlineText__HelperTextWrapper--" + a, {
            "InlineText__HelperTextWrapper--open": s
          }),
          children: ie
        }), /* @__PURE__ */ _(je, {
          className: r("InlineText__ButtonWrapper", "InlineText__ButtonWrapper--" + x),
          children: [/* @__PURE__ */ p(we, {
            className: r("InlineText__SaveButtonWrapper"),
            children: /* @__PURE__ */ p(oe, Object.assign({
              onClick: ee,
              size: x,
              fullWidthMobile: !1,
              id: (i == null || (D = i.saveButton) == null ? void 0 : D.id) || "save-button"
            }, ve, i == null || (j = i.saveButton) == null ? void 0 : j.analyticsData, {
              children: (i == null || (R = i.saveButton) == null ? void 0 : R.buttonText) || "Save"
            }))
          }), /* @__PURE__ */ p(oe, Object.assign({
            size: x,
            fullWidthMobile: !1,
            variant: "secondary",
            id: (i == null || (k = i.cancelButton) == null ? void 0 : k.id) || "cancel-button",
            onClick: te
          }, _e, i == null || (F = i.cancelButton) == null ? void 0 : F.analyticsData, {
            children: (i == null || (H = i.cancelButton) == null ? void 0 : H.buttonText) || "Cancel"
          }))]
        })]
      })
    }) : /* @__PURE__ */ _(ge, Object.assign({
      className: r("InlineText__InlineWrapper", "InlineText__InlineWrapper--" + x, {
        "InlineText__InlineWrapper--disabled": o
      })
    }, !o && {
      onClick: ne,
      onKeyDown: xe
    }, {
      ref: I
    }, Te, {
      children: [/* @__PURE__ */ p(Pe, {
        className: r("InlineText__TextWrapper", "InlineText__TextWrapper--" + x, {
          "InlineText__TextWrapper--disabled": o
        }),
        children: q || K
      }), !s && /* @__PURE__ */ p(Se, {
        className: r("InlineText__IconWrapper", {
          "InlineText__IconWrapper--disabled": o
        }),
        children: /* @__PURE__ */ p(Le, {
          icon: "edit",
          height: "20px",
          width: "20px"
        })
      })]
    })), d && /* @__PURE__ */ p(ae, {
      className: r("InlineText__HelperTextWrapper", "InlineText__HelperTextWrapper--" + a, {
        "InlineText__HelperTextWrapper--open": s
      }),
      children: ie
    })]
  }));
};
export {
  $t as InLineText
};
